import { Typography } from '@mui/material';
import React from 'react';
import CAppPaper from '../../../../app/components/CAppPaper';
import { useTranslation } from 'react-i18next';
import AppFormatPercent from '../../../../app/features/format/AppFormatPercent';
import investmentKpiLang from '../../langs/investmentKpiLang';
import langInvestWordLang from '../../langs/langInvestWordLang';

type CGlobalNetIRRProps = {
	value: number | null;
	isNS?: boolean;
};

const CGlobalNetIRR = (props: CGlobalNetIRRProps) => {
	const { value, isNS } = props;
	const { t } = useTranslation();
	return (
		<CAppPaper
			id="global-net-irr-component"
			variant="elevation"
			color="primary"
			style={{
				//height: '190px',
				padding: '30px 0px',
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				justifyContent: 'center',
			}}
		>
			<Typography variant="h2" component="h2" sx={{ textAlign: 'center', color: 'white', marginBottom: '0px' }}>
				{t(investmentKpiLang.global_net_irr.tag)}
			</Typography>

			<p
				style={{
					margin: '0px',
					fontFamily: "'Poppins'",
					fontStyle: 'normal',
					fontWeight: '700',
					fontSize: '2.5rem',
					lineHeight: '60px',
					textAlign: 'center',
					color: '#2ABDBB',
				}}
			>
				<AppFormatPercent value={value} isNS={isNS} textIfNull={t(langInvestWordLang.nc.tag)} />
			</p>
		</CAppPaper>
	);
};

export default CGlobalNetIRR;
